import { render, staticRenderFns } from "./FirstTimeUserTutorial.vue?vue&type=template&id=8703b274"
import script from "./FirstTimeUserTutorial.vue?vue&type=script&lang=js"
export * from "./FirstTimeUserTutorial.vue?vue&type=script&lang=js"
import style0 from "./FirstTimeUserTutorial.vue?vue&type=style&index=0&id=8703b274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports